import { html, svg, unsafeCSS } from "lit";
import { customElement, property } from "lit/decorators.js";
import EkoElement from "@/utilities/element";
import style from "./file-type-icon.css?inline";

@customElement("eko-file-type-icon")
class FileTypeIcon extends EkoElement {
  static styles = [...EkoElement.styles, unsafeCSS(style)];

  @property({
    reflect: true,
    converter: {
      fromAttribute: (value: string | null) => value?.toLowerCase() || "",
      toAttribute: (value: string) => value.toLowerCase(),
    },
  })
  extension: string = "";

  private getDisplayExtension(): string {
    const ext = this.extension.toLowerCase();
    if (ext.length > 4) {
      return ext.substring(0, 4);
    }
    return ext;
  }

  render() {
    const pageIcon = svg`<svg class="file-type-icon__svg" viewBox="0 0 32 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 0.75H20C20.1212 0.75 20.2375 0.798088 20.3232 0.883789L31.1162 11.6768C31.2019 11.7625 31.25 11.8788 31.25 12V36C31.25 37.7949 29.7949 39.25 28 39.25H4C2.20507 39.25 0.75 37.7949 0.75 36V4C0.750001 2.20507 2.20508 0.75 4 0.75Z" class="file-type-icon__stroke" stroke-width="1.5"/><path d="M20 0.5V8C20 10.2091 21.7909 12 24 12H31.5" class="file-type-icon__stroke" stroke-width="1.5"/></svg>`;

    return html`
      <div class="file-type-icon">
        ${pageIcon}
        <div class="file-type-icon__badge">${this.getDisplayExtension()}</div>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "eko-file-type-icon": FileTypeIcon;
  }
}

export default FileTypeIcon;
